import { useEffect } from 'react';
import type { EffectCallback } from 'react';

/** Как componentDidMount классовых компонентов: эффект один раз при монтировании. */
export default function useComponentDidMount(create: EffectCallback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(create, []);
}
